import { EOL } from 'node:os';
import type { HelpConfiguration } from '@commander-js/extra-typings';
import chalk from 'chalk';
import columnify from 'columnify';
import { LEARN_MORE_LINK } from './constants.js';

export const helpConfiguration: HelpConfiguration = {
  commandUsage(cmd) {
    return `${chalk.bold(cmd.name())} ${cmd.usage()}`;
  },
  formatHelp(cmd, helper) {
    const usage = `${chalk.dim('Usage:')}
  ${helper.commandUsage(cmd)}`;

    const commands = helper.visibleCommands(cmd).map((cmd) => {
      return {
        term: cmd.name(),
        usage: cmd.usage(),
        // `columnify` relies on the order of object keys
        // eslint-disable-next-line perfectionist/sort-objects
        description: helper.commandDescription(cmd),
      };
    });
    const options = helper.visibleOptions(cmd).map((opt) => {
      return {
        term: helper.optionTerm(opt),
        // `columnify` relies on the order of object keys
        // eslint-disable-next-line perfectionist/sort-objects
        description: helper.optionDescription(opt),
      };
    });

    const columnified = columnify([...commands, ...options], {
      columnSplitter: '  ',
      showHeaders: false,
    })
      .split(EOL)
      .map((row) => `  ${row}`);

    const columnifiedOptions = columnified.splice(commands.length);
    const columnifiedCommands = columnified;

    const formattedCommands = `${chalk.dim(
      'Commands:'
    )}${EOL}${columnifiedCommands.join(EOL)}`;

    const formattedOptions = `${chalk.dim(
      'Options:'
    )}${EOL}${columnifiedOptions.join(EOL)}`;

    const learnMore = `${chalk.dim('Learn More:')}
  Learn more at ${LEARN_MORE_LINK}${EOL}`;

    return `${[usage, formattedCommands, formattedOptions, learnMore].join(
      EOL.repeat(2)
    )}${EOL}`;
  },
  sortOptions: true,
  sortSubcommands: true,
};
